$(function () {
    console.log('Hello world');
    if (getQueryParam('cart-drawer') !== null) {
        $('cart-drawer').addClass('active');
    }
})
getQueryParam = (param) => {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
addGiftWrap = (e) => {
    console.log('addGiftWrap');
    var _this = $(e);
    var vid = $(_this).parent().siblings('input[name="id"]').val();
    var isGiftWrap = $(_this).parent().siblings('.jsc-gift-wrap').find('input[id="gift-wrap-checkbox"]').prop('checked');
    var loader = $('.jsc-loader-overlay');

    var addToCartBtn = _this.siblings('.jsc-add-to-cart');

    if(isGiftWrap){
        var _bindId = `45754707443930_${vid}_giftwrap`
        var _html = `<input type="text" name="properties[_bindId]" value="${_bindId}" style="display: none;">`;
        $(_html).insertBefore(_this);
    }

    addToCartBtn.click();
    loader.show();
    setTimeout(() => {
        updateCartGiftWrap();
    }, 3000);
}

updateCartGiftWrap = () => {
    // console.log('updateCartGiftWrap: jsc-reset-style');
    var giftwrapId = 45754707443930;
    var loader = $('.jsc-loader-overlay');
    var giftWrapCount = 0;
    var currentGiftWrapCount = 0;
    var giftWrapInCart = false;

    loader.show();
    jQuery.getJSON('/cart.js', function(cart) {
        var items = cart.items;
        $.each(items, function(index, item){
            // console.log('items: ', item);
            var _bindId = item.properties['_bindId'];
            if (_bindId) {
                var haveGiftWrapId = _bindId.indexOf(giftwrapId) !== -1;
                var haveGiftWrap = _bindId.indexOf("giftwrap") !== -1;

                if (haveGiftWrapId && haveGiftWrap) {
                    giftWrapCount += item.quantity;
                }
            }

            if (item.id == giftwrapId) {
                giftWrapInCart = true;
                currentGiftWrapCount = item.quantity;
            }
        });

        // console.log('currentGiftWrapCount: ', currentGiftWrapCount);
        // console.log('giftWrapCount: ', giftWrapCount);

        if (giftWrapInCart) {
            // console.log('updateItemById');
            if (currentGiftWrapCount != giftWrapCount) {
                CartJS.updateItemById(giftwrapId, giftWrapCount);
            } else if (currentGiftWrapCount <= 0 || giftWrapCount <= 0) {
                CartJS.updateItemById(giftwrapId, 0);
            }
        } else {
            // console.log('addItem');
            CartJS.addItem(
                giftwrapId,
                giftWrapCount,
                {
                    "_giftWrap": true
                }
            );
        }
        

        $(document).on('cart.requestComplete', function(event, cart) {
            // console.log('complete');
            if (window.location.pathname == '/cart') {
                location.href = window.location.pathname;
            } else {
                location.href = window.location.pathname + '?cart-drawer'
            }
            loader.hide();
        });
    });
    loader.hide();
}